import { observable, computed, action } from 'mobx';
import { get } from '@utils/get';

export class AppStore {
    @observable platform = 'pc'; // 'pc' | 'h5'
    @observable deviceType = 'desktop'; // 'desktop' | 'tablet' | 'mobile'
    @observable isOnline = true;
    @observable windowSize = {
        width: typeof window !== 'undefined' ? window.innerWidth : 1024,
        height: typeof window !== 'undefined' ? window.innerHeight : 768,
    };
    @observable currentRoute = '/';
    @observable isLoading = false;

    constructor() {
        // 客户端初始化
        if (typeof window !== 'undefined') {
            this.detectPlatform();
            this.initEventListeners();
        }
    }

    // 计算属性
    @computed get isMobile() {
        return this.platform === 'h5';
    }

    @computed get screenType() {
        const width = this.windowSize.width;
        if (width < 768) return 'mobile';
        if (width < 1024) return 'tablet';
        return 'desktop';
    }

    // Actions
    @action
    setPlatform = (platform) => {
        console.log('[mobx] setPlatform:', platform);

        this.platform = platform;
    };

    @action
    setDeviceType = (deviceType) => {
        this.deviceType = deviceType;
    };

    @action
    setOnlineStatus = (isOnline) => {
        this.isOnline = isOnline;
    };

    @action
    setWindowSize = (size) => {
        this.windowSize = size;
    };

    @action
    setCurrentRoute = (route) => {
        this.currentRoute = route;
    };

    @action
    setLoading = (loading) => {
        this.isLoading = loading;
    };

    // 设备检测
    @action
    detectPlatform = () => {
        if (typeof window === 'undefined') return 'pc';

        const userAgent = navigator.userAgent.toLowerCase();
        const mobileKeywords = [
            'mobile', 'android', 'iphone', 'ipad', 'windows phone',
            'blackberry', 'webos', 'opera mini', 'iemobile'
        ];

        const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword));
        const isMobileScreen = window.innerWidth <= 768;

        const platform = (isMobileUA || isMobileScreen) ? 'h5' : 'pc';
        this.setPlatform(platform);
        return platform;
    };

    // 初始化事件监听
    initEventListeners = () => {
        if (typeof window === 'undefined') return;

        window.addEventListener('online', () => this.setOnlineStatus(true));
        window.addEventListener('offline', () => this.setOnlineStatus(false));

        window.addEventListener('resize', () => {
            this.setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
            // 窗口大小变化时重新检测平台
            this.detectPlatform();
        });
    };
}

const appStore = new AppStore();
export default appStore;